module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero-teenagers-0bd8dcde2387305fa6f3d4d1821cfd8d.svg";